import firebase from 'firebase';
import UserApi from './UserApi';


class TableApi {
    async getTableData(impersonate) {
        try {
            let data = await firebase.functions().httpsCallable('grabTableData')();
            return data.data;
        } catch (e) {
            UserApi.crashReport("Crashed in Cashflow")
            return Promise.reject(e);
        }
    }
}

export default new TableApi();